import { Action } from './types'

export const isJSXAction = (
  action?: Action | Action[],
): action is JSX.Element => {
  return (
    !!action &&
    typeof action === 'object' &&
    action !== null &&
    'type' in action
  )
}
